export type SCENES = 'MAP_SCENE' | 'NOT_SUPPORTED_SCENE' | 'NOT_FOUND';
export const MAP_SCENE: SCENES = 'MAP_SCENE';
export const NOT_SUPPORTED_SCENE: SCENES = 'NOT_SUPPORTED_SCENE';
export const NOT_FOUND_SCENE: SCENES = 'NOT_FOUND';
